import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { EquipmentType } from '@frontend/equipment/types';
import React from 'react';

const ID = 'equipment-type-select';
export const EquipmentTypeSelect = (props: Omit<SelectInputV2Props<string>, 'options'>) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            options={Object.values(EquipmentType).map((c) => ({ label: c, value: c }))}
            label={props.label || 'Equipment type'}
        />
    );
};
